import React from "react";
import { userNoteService } from "../../../services/userNoteService";

const MAX_NOTE_LENGTH = 5000;

function ProgramSiteUserNoteForm({ show, onClose, programSiteId, onNoteCreated }) {
  const [noteBody, setNoteBody] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState("");
  const [success, setSuccess] = React.useState(false);

  // Reset form state when modal opens
  React.useEffect(() => {
    if (show) {
      setSubmitting(false);
      setError("");
      setSuccess(false);
      setNoteBody("");
    }
  }, [show]);

  const charactersRemaining = MAX_NOTE_LENGTH - noteBody.length;

  async function handleSubmit(e) {
    e.preventDefault();
    const trimmed = noteBody.trim();
    if (!trimmed) {
      setError("Note cannot be empty.");
      return;
    }
    if (trimmed.length > MAX_NOTE_LENGTH) {
      setError(`Note must be ${MAX_NOTE_LENGTH} characters or fewer.`);
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      await userNoteService.create({
        program_site_id: programSiteId,
        note: trimmed,
      });
      setNoteBody("");
      setSuccess(true);
      if (onNoteCreated) onNoteCreated();
    } catch (err) {
      setError("Unable to save note. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  if (!show) return null;

  return (
    <div className="modal update-type-selection-modal programSiteUserNoteFormModal" role="dialog" tabIndex="-1" style={{ display: "block", zIndex: 9999 }}>
      <div className="modal-backdrop fade in" onClick={onClose} style={{ zIndex: -1 }} />
      <div className="modal-dialog modal-lg" role="document">
        <div className="share-content">
          <div className="modal-content">
            <div className="modal-header">
              <a className="close-modal" aria-label="Close" onClick={onClose} role="button">
                <span aria-hidden="true">&times;</span>
              </a>
              <h4 className="sub-headliner">Submit an update to this listing</h4>
            </div>
            <div className="modal-body">
              {success ? (
                <p style={{ margin: "3em 0", textAlign: "center" }}>
                  <i className="ico ico-verified" style={{ color: "#3c763d" }} />
                  {" "}Thank you for posting a note regarding this listing.
                </p>
              ) : (
                <form onSubmit={handleSubmit}>
                  {error && (
                    <div className="user-note-error-message error_messages">
                      {error}
                    </div>
                  )}
                  <div className="field">
                    <label htmlFor="note">
                      Note or suggested edit:
                      <span style={{ marginLeft: "1em" }}>
                        <span className="characters-remaining" style={{ fontWeight: "bold" }}>
                          {charactersRemaining}
                        </span>
                        {" "}characters remaining
                      </span>
                    </label>
                    <textarea
                      className="input login-input character-limited-textarea"
                      name="note"
                      id="note"
                      autoFocus
                      placeholder=""
                      rows={4}
                      value={noteBody}
                      onChange={(e) => setNoteBody(e.target.value)}
                      maxLength={MAX_NOTE_LENGTH}
                    />
                  </div>
                  <button className="create-user-note btn btn-primary" name="Add" type="submit" disabled={submitting || !noteBody.trim()}>
                    {submitting ? "Submitting..." : "Submit a note"}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProgramSiteUserNoteForm;
